<form action="">
    <div class="row">
        <div class="col-6">
            <div class="row">
                <div class="col-12">FirstName</div>
                <dx-text-box class="col-12 m-2" [(value)]="admin.firstName"></dx-text-box>
            </div>
            <div class="row">
                <div class="col-12">LastName</div>
                <dx-text-box class="col-12 m-2" [(value)]="admin.lastName"></dx-text-box>
            </div>
        </div>
        <div class="col-6 p-3">
            <img [src]="logoSrc" alt="Logo" class="w-100 h-100">
            <label for="fileInput" class="logo-edit"><i class="fas fa-edit fa-2x"></i></label>
            <input id="fileInput" type="file" hidden accept="image/jpeg, image/png" (change)="onLogoSelect($event)">
        </div>
    </div>
    <div class="row">
        <div class="col-12">Email</div>
        <dx-text-box class="col-12 m-2" [(value)]="admin.email"></dx-text-box>
    </div>
    <div class="row mb-2 mt-2">
        <div class="col-4">Account access</div>
        <div class="col-2">
            <dx-switch switchedOnText="Yes" switchedOffText="No" [(value)]="admin.isActive"></dx-switch>
        </div>
    </div>
    <div class="row">
        <div class="col-12">Phone</div>
        <dx-text-box class="col-12 m-2" [(value)]="admin.phone"></dx-text-box>
    </div>
    <div class="row">
        <div class="col-12">Business Name</div>
        <dx-text-box class="col-12 m-2" [(value)]="admin.business"></dx-text-box>
    </div>
    <div class="row">
        <div class="col-md-6">
            <div class="col-12">Broker Licenses</div>
            <dx-number-box class="col-12 mt-2" [(value)]="admin.licenses.broker"></dx-number-box>
        </div>
        <div class="col-md-6">
            <div class="col-12">Client Licenses</div>
            <dx-number-box class="col-12 mt-2" [(value)]="admin.licenses.client"></dx-number-box>
        </div>
    </div>
    <div class="row">
        <div class="col-12">Broker Group</div>
        <dx-select-box [items]="brokerGroupList" displayExpr="name" valueExpr="_id" class="col-12 m-2"
            (onValueChanged)="onBrokerChanged()" [(value)]="admin.brokerGroup"></dx-select-box>
    </div>
    <div class="row">
        <div class="col-12">Surveys</div>
        <dx-tag-box [items]="surveyList" displayExpr="name" valueExpr="_id" class="col-12 m-2"
            [(value)]="admin.surveys"></dx-tag-box>
    </div>
    <div class="row mt-2">
        <div class="col-6"></div>
        <div class="col-6">
            <dx-button class="w-100 h-100" type="success" (onClick)="onSaveHandler()">
                Save
            </dx-button>
        </div>
    </div>
</form>